<template>
    <div>
        <v-row justify="center" no-gutters class="px-4 pt-3 pb-8">
            <v-col cols="10" class="text-h5 text-md-h5 text-lg-h5 font-weight-bold">
                <div>Cancel Confirmation</div>
            </v-col>
            <v-col cols="2" class="text-right">
                <slot name="closeCancel"></slot>
            </v-col>
        </v-row>
        
        <v-row no-gutters class="pb-4 px-4">
            <v-col cols="12" class="font-weight-bold">
                <div>
                    <v-icon color="#F1B300" small class="mr-2">fa-solid fa-triangle-exclamation</v-icon>
                    {{ iconText }}
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters class="pb-8 px-4">
            <v-col cols="12">
                <div>{{ breadText }}</div>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="text-right px-4">
                <slot name="cancelActions"></slot>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props:["iconText", "breadText"],
    data(){
        return {};
    },
    methods:{}
}
</script>
<style></style>
